<h1 class="center">Modification de la livraison du {{ commandeDetails?.date_livraison | date: 'EEEE': 'fr' }}
	{{ commandeDetails?.date_livraison | date: 'dd/MM/yyyy': 'fr'}}</h1>
<nav *ngIf="isSendable()" hideIfNot="!ROLE_HEBERGEMENT_LINGERE">
	<a class="tabs-orders" [ngClass]="isSelected ? 'tabs-orders-selected' : ''" routerLinkActive="active-link"
		(click)="reloadData(true)">Inventaires</a>
	<a class="tabs-orders" [ngClass]="!isSelected ? 'tabs-orders-selected' : ''" routerLinkActive="active-link"
		(click)="reloadData(false)">Commande</a>
</nav>
<div class="container" *ngIf="isSelected">
	<div *ngIf="loading; else commandeEditTemplate" class="flex justify-center">
		<mat-spinner></mat-spinner>
	</div>
	<ng-template #commandeEditTemplate>
		<div class="flex justify-center">
			<div class="clamp-commande">
				<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="mt-2.5">
					<mat-nested-tree-node *matTreeNodeDef="let inventaire">
						<div *ngIf="inventaire.inventaire_lignes.length > 0">
							<div class="mat-tree-node">
								<button type="button" mat-icon-button matTreeNodeToggle
									[attr.aria-label]="'Toggle ' + inventaire.lingerie.id">
									<mat-icon class="mat-icon-rtl-mirror">
										{{treeControl.isExpanded(inventaire) ? 'expand_more' : 'chevron_right'}}
									</mat-icon>
								</button>
								<div>{{inventaire.lingerie.libelle}}</div>
								<div>
									<span [ngClass]="'state-circle ' + 'state-circle-' + inventaire.statut.code"></span>
									{{ inventaire.statut.libelle }}
								</div>
							</div>
							<div [class.example-tree-invisible]="!treeControl.isExpanded(inventaire)"
								class="content-node">
								<table class="styled-table">
									<thead>
										<tr>
											<th>Article</th>
											<th *ngIf="enabledCoeff">Quantité max</th>
											<th *ngIf="!enabledCoeff">Dotation</th>
											<th>Restant</th>
											<th>Pre-commande</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let ligne of inventaire.inventaire_lignes">
											<td>{{ ligne.article.designation }}</td>
											<td>{{ ligne.dotation }}</td>
											<td>
												<mat-form-field>
													<mat-label></mat-label>
													<input type="number" matInput #restant [value]="ligne.restant" min=0
														(keypress)="omit_not_number($event)" max="ligne.dotation"
														(change)="updateInventaire(ligne, $event)" #txtInput
														(keydown.enter)="txtInput.blur()" [disabled]="isDisabled(ligne)">
												</mat-form-field>
											</td>
											<td>{{ ligne.restant != null ? ligne.qte_commande : 'Non inventorié' }}</td>
											<mat-icon *ngIf="!haveQteStock(ligne)" class="warning-stock"
												matTooltip="Cet article n'est actuellement pas en stock, il n'est donc pas commandable">
												warning
											</mat-icon>
										</tr>
									</tbody>
								</table>
								<button mat-raised-button type="button" (click)="saveInventaire(inventaire)"
									[disabled]="isSendable()">
									Enregistrer
								</button>
							</div>
						</div>
					</mat-nested-tree-node>
				</mat-tree>
			</div>
		</div>
		<div class="buttons-center">
			<button mat-raised-button (click)="refuse()" color="white">Retour</button>
			<button mat-raised-button type="button" [disabled]="isSendable()" (click)="openDialog()"
				hideIfNot="!ROLE_HEBERGEMENT_LINGERE">Valider</button>
		</div>
	</ng-template>
</div>
<div class="container" *ngIf="!isSelected">
	<div class="flex justify-center">
		<div class="clamp-commande">
			<table class="styled-table">
				<thead>
					<tr>
						<th>Article</th>
						<th>Max commandable</th>
						<th>Pré-commande</th>
						<th>Commandé *</th>
						<th *ngIf="enabledConditionnement">Conditionnement</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let data of commandeDetails.lod_ligne_commandes">
						<td>{{ data.article.designation }}</td>
						<td>{{getSommeDotationsArticle(data.article.id)}}</td>
						<td>{{ data.preCommande }}</td>
						<td>
							<mat-form-field>
								<mat-label></mat-label>
								<input type="number" matInput #commande [value]="data.quantite" min=0
									max="getSommeDotationsArticle(data.article.id)"
									(change)="updateCommande(data, data.article.id, $event)" #txtInput
									(keydown.enter)="txtInput.blur()">
							</mat-form-field>
						</td>
						<td *ngIf="enabledConditionnement" style="color: grey">
							{{ getConditionnement(data.article) ?? 'Non Renseigné' }}
						</td>
					</tr>
				</tbody>
			</table>
			<div class="pt-2.5">* Les quantités livrées pourront être ajustées au plus près des quantités
				commandées, au moment de la préparation, pour garantir une livraison dans les meilleurs délais.
			</div>
			<div class="buttons-center">
				<button mat-raised-button (click)="refuse()" color="white">Retour</button>
				<button mat-raised-button type="submit" (click)="saveCommande()"
					[disabled]="loading || this.commandeDetails.statut.code == 'DD'">
					Enregistrer
				</button>
				<button mat-raised-button type="button" (click)="openDialogSend()" [disabled]="loading">
					Enregistrer & Transmettre
				</button>
			</div>
		</div>
	</div>
</div>
<router-outlet></router-outlet>